var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container-fluid" },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.editMode || (_vm.editMode && _vm.editFull),
              expression: "!editMode || (editMode && editFull)",
            },
          ],
          staticClass: "row pb-2",
        },
        [
          _c("div", { staticClass: "col-7 col-no-padding" }, [
            _c("form", { staticClass: "form" }, [
              _c("div", { staticClass: "form-row row" }, [
                _c("label", { staticClass: "col-12" }, [
                  _vm._v(_vm._s(_vm.$t("plans.form.label"))),
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.label,
                      expression: "label",
                    },
                  ],
                  ref: "label",
                  staticClass: "form-input col-12",
                  class: _vm.isLabelMissing && "invalid",
                  attrs: { type: "text" },
                  domProps: { value: _vm.label },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.label = $event.target.value
                    },
                  },
                }),
                _vm._v(" "),
                _vm.isLabelMissing
                  ? _c("p", { staticClass: "text-danger-600 m-0" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("validation.required_field")) +
                          "\n          "
                      ),
                    ])
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-row row" },
                [
                  _c("label", { staticClass: "col-12" }, [
                    _vm._v(_vm._s(_vm.$t("plans.form.address"))),
                  ]),
                  _vm._v(" "),
                  _c("AddressField", {
                    staticClass: "w-full",
                    attrs: {
                      center: _vm.center,
                      zoom: _vm.zoom,
                      address: _vm.address,
                      fullAddress: _vm.address,
                    },
                    on: {
                      location: _vm.handleLocation,
                      centerMap: _vm.handleMapCenter,
                    },
                  }),
                ],
                1
              ),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-5 col-no-padding" },
            [
              _c("MiniMap", {
                ref: "minimap",
                attrs: {
                  id: "minimap-site",
                  center: _vm.center,
                  zoom: _vm.zoom,
                },
                on: { centerMap: _vm.handleMapCenter },
              }),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.editMode && !_vm.editFull,
              expression: "editMode && !editFull",
            },
          ],
          staticClass: "row pb-2",
        },
        [
          _c("div", { staticClass: "col-12 col-no-padding" }, [
            _c("form", { staticClass: "form" }, [
              _c("div", { staticClass: "form-row row" }, [
                _c("label", { staticClass: "col-12" }, [
                  _vm._v(_vm._s(_vm.$t("plans.form.label"))),
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.label,
                      expression: "label",
                    },
                  ],
                  staticClass: "form-input col-12",
                  class: _vm.isLabelMissing && "invalid",
                  attrs: { type: "text" },
                  domProps: { value: _vm.label },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.label = $event.target.value
                    },
                  },
                }),
                _vm._v(" "),
                _vm.isLabelMissing
                  ? _c("p", { staticClass: "text-danger-600 m-0" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("validation.required_field")) +
                          "\n          "
                      ),
                    ])
                  : _vm._e(),
              ]),
            ]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "Toolbar",
        { staticClass: "not-fixed pb-3 px-3" },
        [
          _c(
            "Btn",
            {
              staticClass: "primary",
              nativeOn: {
                click: function ($event) {
                  $event.stopPropagation()
                  return _vm.handleSave($event)
                },
              },
            },
            [_vm._v("\n      " + _vm._s(_vm.$t("global.save")) + "\n    ")]
          ),
          _vm._v(" "),
          _c(
            "Btn",
            {
              nativeOn: {
                click: function ($event) {
                  $event.stopPropagation()
                  return _vm.cancel($event)
                },
              },
            },
            [_vm._v("\n      " + _vm._s(_vm.$t("global.cancel")) + "\n    ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }